<ix-content-header slot="header" header-title="Admin project overview"> </ix-content-header>
@if (!areProjectsLoading) {
  <div>
    @if (projects.length) {
      <table class="ix-table ix-table-striped">
        <colgroup>
          <col class="column-number" />
          <col class="column-name" />
          <col class="column-user" />
          <col class="column-actions" />
        </colgroup>
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Name</th>
            <th scope="col">User</th>
            <th scope="col">Actions</th>
          </tr>
        </thead>
        <tbody>
          @for (project of projects; track project; let i = $index) {
            <tr>
              <th scope="row">{{ i }}</th>
              <td>{{ project.name }}</td>
              <td>{{ project.owner }}</td>
              <td>
                <ix-icon-button
                  variant="primary"
                  icon="start-data-analysis"
                  (click)="startCalculation(project.id)"
                ></ix-icon-button>
                <ix-icon-button icon="pen" variant="secondary" (click)="editProject(project)"></ix-icon-button>
                <ix-icon-button icon="trashcan" variant="secondary" (click)="openDeleteModal(project)"></ix-icon-button>
                <ix-icon-button
                  icon="download"
                  variant="secondary"
                  (click)="downloadProjectFile(project)"
                ></ix-icon-button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    }
    @if (projects && projects.length === 0) {
      <ix-empty-state header="No projects available"></ix-empty-state>
    }
  </div>
}

<app-project-modals #projectModals></app-project-modals>
